export const GET = 'get';
export const POST = 'post';
export const PATCH = 'patch';
export const PUT = 'put';
export const DELETE = 'delete';
